import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ClientContext } from 'graphql-hooks';
import { Provider } from 'react-redux';
import { store } from 'store';
import { BrowserRouter } from 'react-router-dom';
import { TreeSelectionProvider } from 'contexts/TreeSelectionContext';
import { UploadArticlesPublishProvider } from 'contexts/UploadArticlesPublishContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { graphQLClient } from 'graphql/graphQLClient';

// Configurar TanStack Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos
      cacheTime: 10 * 60 * 1000, // 10 minutos
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

console.log('process.env.REACT_APP_BACKEND_URL', process.env.REACT_APP_BACKEND_URL);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ClientContext.Provider value={graphQLClient}>
        <UploadArticlesPublishProvider>
          <Provider store={store}>
            <BrowserRouter>
              <TreeSelectionProvider>
                <App />
              </TreeSelectionProvider>
            </BrowserRouter>
          </Provider>
        </UploadArticlesPublishProvider>
      </ClientContext.Provider>
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
